import { Link as ChakraLink } from '@chakra-ui/react'
import { Body1Strong } from 'components/typography'
import { FC } from 'react'

// Inline elements only: Markdown links sit inside a <p>, and the Datafolha pages are server-rendered
// (a <p> inside a <p> breaks hydration).
const MarkdownLink: FC<any> = (props) => {
  return (
    <ChakraLink display="inline-block" {...props}>
      <Body1Strong as="span" fontWeight={700} color="green.250">
        {props.children}
      </Body1Strong>
    </ChakraLink>
  )
}

export default MarkdownLink
